export default "__VITE_ASSET__Da_7$uMC__"